import React, { useRef } from "react";
import { Grid } from "semantic-ui-react";
import EvaluationCard from "./EvaluationCard";

const EvaluatedCriteria = ({ evaluatedcriterion_set }) => {
  const criterionRef = useRef(null);

  return (
    <Grid ref={criterionRef} columns={1}>
      {evaluatedcriterion_set.map((evaluatedcriterion) => {
        return (
          <Grid.Row
            style={{ paddingTop: "0.5em", paddingBottom: "0.5em" }}
            id={`criterion_int_id_${evaluatedcriterion.criterion.int_id}`}
          >
            <Grid.Column>
              <EvaluationCard evaluatedcriterion={evaluatedcriterion} />
            </Grid.Column>
          </Grid.Row>
        );
      })}
    </Grid>
  );
};

export default EvaluatedCriteria;
